import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import productSearchQuery from '~/graphql/productSearch.gql';
import productSearchAlgolia from '~/graphql/productSearchAlgolia.gql';
import { buildCategoryProductsQuery as buildAlgoliaCategoryProductsQuery } from '~/helpers/algolia-extract-helper';
import { buildCategoryProductsQuery } from '~/helpers/extract-helper';
import SEARCH_PROVIDER from '~/helpers/search-data-helpers';
function fetchCorvusAlgoliaSearch(_x, _x2, _x3, _x4) {
  return _fetchCorvusAlgoliaSearch.apply(this, arguments);
}
function _fetchCorvusAlgoliaSearch() {
  _fetchCorvusAlgoliaSearch = _asyncToGenerator(function* (context, keyword, query, withMarketplace) {
    var locale = context.state.i18n.currentLocale.iso;
    var algoliaUserToken = context.$cookies.get('_ALGOLIA') || '';
    var {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy,
      page,
      algoliaFilters
    } = buildAlgoliaCategoryProductsQuery(query);
    var {
      data: {
        productSearchAlgolia: productSearch
      }
    } = yield context.app.apolloProvider.defaultClient.query({
      query: productSearchAlgolia,
      variables: {
        variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
        locale,
        keyword,
        offset,
        limit,
        sortBy,
        orderBy,
        filterBy,
        page,
        algoliaFilters,
        algoliaUserToken,
        withMarketplace
      }
    });
    var response = {
      productSearch
    };
    return response;
  });
  return _fetchCorvusAlgoliaSearch.apply(this, arguments);
}
function fetchElasticSearch(_x5, _x6, _x7) {
  return _fetchElasticSearch.apply(this, arguments);
}
function _fetchElasticSearch() {
  _fetchElasticSearch = _asyncToGenerator(function* (context, keyword, query) {
    var locale = context.state.i18n.currentLocale.iso;
    var {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy
    } = buildCategoryProductsQuery(query);
    var response = yield context.app.apolloProvider.defaultClient.query({
      query: productSearchQuery,
      variables: {
        variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
        locale,
        keyword,
        offset,
        limit,
        sortBy,
        orderBy,
        filterBy
      }
    });
    return response.data;
  });
  return _fetchElasticSearch.apply(this, arguments);
}
function fetchSearch(_x8, _x9, _x10, _x11) {
  return _fetchSearch.apply(this, arguments);
}
function _fetchSearch() {
  _fetchSearch = _asyncToGenerator(function* (context, keyword, query, withMarketplace) {
    var searchResponse;
    if (SEARCH_PROVIDER(context) === 'algolia') {
      var _searchResponse, _searchResponse$produ, _searchResponse2, _searchResponse2$prod;
      searchResponse = yield fetchCorvusAlgoliaSearch(context, keyword, query, withMarketplace);
      var canRunAlgolia = ((_searchResponse = searchResponse) === null || _searchResponse === void 0 ? void 0 : (_searchResponse$produ = _searchResponse.productSearch) === null || _searchResponse$produ === void 0 ? void 0 : _searchResponse$produ.products.length) || ((_searchResponse2 = searchResponse) === null || _searchResponse2 === void 0 ? void 0 : (_searchResponse2$prod = _searchResponse2.productSearch) === null || _searchResponse2$prod === void 0 ? void 0 : _searchResponse2$prod.details.redirect);
      if (canRunAlgolia) {
        return searchResponse;
      }
    }
    searchResponse = fetchElasticSearch(context, keyword, query);
    return searchResponse;
  });
  return _fetchSearch.apply(this, arguments);
}
export default fetchSearch;